import React from "react";
import CriticalError from "../components/CriticalError";


export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hasError: false,
			error: undefined
		};
	}

	static getDerivedStateFromError(error) {
		return {
			hasError: true,
		};
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			error : 		error.toString(),
			errorInfo : 	errorInfo
		})
	}

	render() {
		if (this.state.hasError) {
			return <CriticalError error={this.state.error} errorInfo={this.state.errorInfo}/>;
		} else {
			return this.props.children;
		}
	}
}